function DonateToProject() {
	// Country Data
	var _countryData;
	this.setCountryData = function( obj ) {
		_countryData = obj;
	};
	this.getCountryData = function() {
		return _countryData;
	};
	this.getDataOfCountry = function( code ){
		for( var i=0; i < _countryData.length; i++ ) {
			if( _countryData[i].code == code ) return _countryData[i];
		}
		return null;
	};

	// Events
	this.onCountryHover = function( code ) {
		var regionColor = "#" + this.getDataOfCountry(code).color.substring(2);
		$("ul.regions li.region_" + code + " a.regionName").each(function(i){
				this.oldColor = $(this).css("color");
				$(this).css("color", regionColor);
			});
	};
	this.onCountryUnhover = function( code ) {
		$("ul.regions li.region_" + code + " a").each(function(i){
			$(this).css("color", this.oldColor);
		});
	};
	this.onCountryRelease = function( code ) {
		var baseHref = $('base').attr("href");
		$('div#countryContent').load(
				baseHref + 'donate/to-project.html?regionCode=' + code + " #countryContent > *",
				{},
				function(responseText, textStatus, xmlHttpRequest) {
					setup();
				}
			);
		this.scrollTo( $('div#countryContent') );
	};
	this.scrollTo = function( where ) {
		$.scrollTo( where, 500, {offset:{left: 0, top: -20 }} ); // Scroll to the content.
	};
}
function CountryData( code, color, name ) {
	this.code = code;
	this.color = color;
	this.name = name;
}
